import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue'
import ResizeHandle from '@/components/ResizeHandle.vue'
import { getScrollAreaHeight, resizableHeightStyle } from '@/services/functions'

type Props = {
  scrollAreaSelector?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ResizableList',
  props: {
    scrollAreaSelector: {}
  },
  setup(__props: any) {

const props = __props

const root = ref<HTMLElement | null>(null)
const height = ref<number | null>(null)

const heightStyle = computed(() => resizableHeightStyle(height.value))
function scrollAreaHeight(): number {
  return getScrollAreaHeight(root.value, props.scrollAreaSelector)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "resizable-list",
    ref_key: "root",
    ref: root,
    style: _normalizeStyle(heightStyle.value)
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(ResizeHandle, {
      getHeight: scrollAreaHeight,
      height: height.value,
      "onUpdate:height": _cache[0] || (_cache[0] = ($event: any) => ((height).value = $event))
    }, null, 8, ["height"])
  ], 4))
}
}

})